export default __webpack_public_path__ + "static/media/sponsor_block_1.7a25a149.webp";